module.exports = __webpack_public_path__ + "img/wifi.a28621be.svg";